import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LinkIconModule } from '@shared/link-icon/link-icon.module';
import {
  ErrorStateMatcher,
  JbAvatarModule,
  JbErrorModule,
  JbFlyoutModule,
  JbFormFieldContainerModule,
  JbInputModule,
  JbPopoverModule,
  ShowOnSubmitErrorStateMatcher,
} from 'jb-component-library';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
} from 'ng-recaptcha';

import { HeaderSignedInDialogModule } from '../header/header-signed-in-dialog/header-signed-in-dialog.module';
import { UIModule } from '../ui';
import { ENV_CONFIG } from './../../core/injection-tokens';
import { captchaFactory, configFactory } from './../../global-factories';
import { TRUEBLUE_LOGGED_IN_DECLARATIONS } from './tb-logged-in';
import { TRUEBLUE_LOGIN_DECLARATIONS } from './tb-login';
import { TrueblueComponent } from './trueblue.component';

const MODULES = [
  CommonModule,
  UIModule,
  ReactiveFormsModule,
  RecaptchaModule,
  RecaptchaFormsModule,
  JbPopoverModule,
  JbFlyoutModule,
  JbInputModule,
  JbFormFieldContainerModule,
  JbErrorModule,
  JbAvatarModule,
  HeaderSignedInDialogModule,
  LinkIconModule,
];

const DECLARATIONS = [
  TrueblueComponent,
  TRUEBLUE_LOGIN_DECLARATIONS,
  TRUEBLUE_LOGGED_IN_DECLARATIONS,
];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
  providers: [
    { provide: ENV_CONFIG, useFactory: configFactory },
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: captchaFactory,
      deps: [ENV_CONFIG],
    },
    { provide: ErrorStateMatcher, useClass: ShowOnSubmitErrorStateMatcher },
  ],
})
export class TrueblueModule {}
